export default (
  state = {
    appVersion: {
      newVersionFound: false,
      isMajorRelease: null,
    },
    authData: false,
    currentUserPermissions: [],
    hasUnseenInboxNotifications: false,
  },
  action,
) => {
  switch (action.type) {
    case "TRIGGER_NEW_APP_NOTIFICATION":
      return {
        ...state,
        appVersion: action.payload,
      };
    case "CHANGE_AUTH":
      return {
        ...state,
        authData: action.payload,
      };
    case "CURRENT_USER_PERMISSIONS":
      return {
        ...state,
        currentUserPermissions: action.payload,
      };

    case "INBOX_SEEN_UNSEEN_NOTIFICATIONS":
      return {
        ...state,
        hasUnseenInboxNotifications: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/CommonReducer.js